import React from "react"
import { isEmpty } from "lodash-es"
import { auditShape } from "utils/propTypeShapes"
import { ImpersonationBadge } from "shared/badges"

const FALLBACK_USER_NAME = "Anonymous"

const AuditedUser = ({ audit }) => {
  const { impersonator, user } = audit

  const userName = user.attributionName || FALLBACK_USER_NAME

  if (isEmpty(impersonator)) {
    return (
      <span className="font-semibold">
        { userName }
      </span>
    )
  }

  return (
    <span className="font-semibold inline-block mr-1 screenreader-whitespace">
      <span className="mr-2">
        {impersonator.impersonatorAttributionName} as {userName}
      </span>
      <ImpersonationBadge text="Impersonator" />
    </span>
  )
}

AuditedUser.propTypes = {
  audit: auditShape.isRequired,
}

export default AuditedUser
